import { createApp } from "vue";
import App from "./App.vue";
import "./assets/shared.css";
import "./assets/variables.css";
import router from "./router";

createApp(App).use(router).mount("#app");
